export enum QuoteLineItemType {
  TC,
  PC,
  AN,
  PT,
  MI,
}
